import { retrieveCustomerHome } from '@amzn/vinyl-amzn/cbl'
import { getAuth } from '@/auth/authRef'
import { loadDeviceInfo } from '@/device/device'

/**
 * The signed-in customer's id: a cookie session's boot config carries it; a token session reads it
 * from Stratus `retrieveCustomerHome`, as the Morpho desktop client does. Null when signed out.
 */
export async function loadCustomerId(): Promise<string | null> {
    const auth = getAuth()
    if (!auth.usesBearer()) return auth.getCustomerId?.() ?? null
    if (!auth.isSignedIn()) return null
    const [oAuthToken, { deviceId, deviceType }] = await Promise.all([
        auth.authTokenProvider(),
        loadDeviceInfo(),
    ])
    const { customerId } = await retrieveCustomerHome({ oAuthToken }, { deviceId, deviceType })
    return customerId || null
}
